export type ArtworkTemplateGroupModel = {
  brandId: number,
  cacheKey: number,
  description: string,
  id: number,
  name: string,
  productLineId: string,
}

export type ArtworkTemplateGroupRequestOptions = {}

const state = {
  description: '',
  id: null,
  name: '',
  productLineId: '',
}

export const requiredFields = [
  { key: 'name' },
]

export default state
